import reduceReducers from 'reduce-reducers';

import thankYouReducer from './thankYou-reducer';

export default reduceReducers(thankYouReducer);
